import { Component, OnInit, Injector, Input, OnChanges, NgModule, ElementRef } from '@angular/core';
import { BaseComponent } from "../../base.component";

@Component({
  selector: 'custom-icon',
  template: `
<div class="icon-container"
tabindex="0"
[ngClass]="{ disabled: control.disabled }"
(click)="!control.disabled && CallajaxAction()"
(keypress)="onKeyPress($event)">
<i class="icon" [ngClass]="'icon-' + control.attributes.icon"></i>
</div>
`,
  styleUrls: ['./custom-icon.component.scss']
})

export class CustomIconComponent extends BaseComponent {
  constructor(injector: Injector) {
    super(injector)
  }

  CallajaxAction() {
    this.actionService.ajaxAction(this.control.ajaxInfo, this.context);
  }

  onKeyPress(event) {
    //if 'SPACE' or 'ENTER' key pressed, then perform searching
    if (event.keyCode === 32 || event.keyCode === 13) {
      if (event.keyCode === 32)
        event.preventDefault();
      this.control.disabled = !this.control.disabled;
      this.CallajaxAction();
    }
  }
}
